import {useContext, useEffect} from "react";
import {ToastContext} from "../../contexts";

export const Toast = () => {
  const toasts = useContext(ToastContext);

  useEffect(() => {
    if (toasts.toast.length > 0) {
      setTimeout(() => {
        let tempArray = [...toasts.toast];
        if (tempArray.length === 1) {
          tempArray.pop();
        } else {
          for (let i = 0; i < tempArray.length-1; i++) {
            tempArray[i] = tempArray[i+1];
          }
          tempArray.pop();
        }
        toasts.setToast({toast: tempArray, setToast: toasts.setToast})
      }, 4000);
    }
  });

  return(
    <div className="toasts">
      {toasts.toast.length > 0 && toasts.toast.map((item, index) => (
        <div className={"toast " + item.tipo} key={index}>
          {item.texto}
        </div>
      ))}
    </div>
  );
}